import { useCallback, useEffect, useRef, useState } from 'react'
import { getElementFont } from '../utils/measureTextWidth'

export function useMeasuredElementFont<T extends HTMLElement>() {
  const [measurementFont, setMeasurementFont] = useState<string | null>(null)
  const observerRef = useRef<ResizeObserver | null>(null)

  const setMeasuredElement = useCallback((node: T | null) => {
    observerRef.current?.disconnect()
    observerRef.current = null
    if (!node) return

    const updateMeasurementFont = () => {
      const nextFont = getElementFont(node)
      setMeasurementFont((current) => (current === nextFont ? current : nextFont))
    }
    updateMeasurementFont()

    if (typeof ResizeObserver !== 'undefined') {
      observerRef.current = new ResizeObserver(updateMeasurementFont)
      observerRef.current.observe(node)
    }
  }, [])

  useEffect(() => () => observerRef.current?.disconnect(), [])

  return { measurementFont, setMeasuredElement }
}
